import { BaseService } from './base.service';
import type {
  IntakeCandidateChoice,
  IntakeCheckResponse,
  IntakeEscalateResponse,
  IntakeFormData,
} from '@/types/intake';

/** Shared JSON body shape for both /check and /escalate — the 6 form fields, never the attachment. */
function formFields(form: IntakeFormData) {
  return {
    requestType: form.requestType,
    product: form.product,
    locationId: form.locationId,
    whatHappened: form.whatHappened,
    whosAffected: form.whosAffected,
    severity: form.severity,
  };
}

export class IntakeService extends BaseService {
  constructor() {
    super('/intake');
  }

  check(
    form: IntakeFormData,
    choice?: IntakeCandidateChoice,
  ): Promise<IntakeCheckResponse> {
    return this.post<IntakeCheckResponse>('/check', {
      ...formFields(form),
      ...(choice ?? {}),
    });
  }

  escalate(
    form: IntakeFormData,
    escalationToken?: string,
  ): Promise<IntakeEscalateResponse> {
    if (!form.attachment) {
      return this.post<IntakeEscalateResponse>('/escalate', {
        ...formFields(form),
        ...(escalationToken !== undefined ? { escalationToken } : {}),
      });
    }
    const formData = new FormData();
    Object.entries(formFields(form)).forEach(([key, value]) => {
      if (value === undefined) return;
      formData.append(key, String(value));
    });
    if (escalationToken !== undefined) {
      formData.append('escalationToken', escalationToken);
    }
    formData.append('files', form.attachment);
    return this.post<IntakeEscalateResponse>('/escalate', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export const intakeService = new IntakeService();
